import { render, staticRenderFns } from "./excerpt-card.vue?vue&type=template&id=91830a02&scoped=true"
import script from "./excerpt-card.vue?vue&type=script&lang=js"
export * from "./excerpt-card.vue?vue&type=script&lang=js"
import style0 from "./excerpt-card.vue?vue&type=style&index=0&id=91830a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91830a02",
  null
  
)

export default component.exports